import { Directive, ElementRef, Input, HostBinding, OnInit, Renderer2 } from '@angular/core';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';

@Directive({
  selector: '[appColorHighlight]'
})
export class ColorHighlightDirective implements OnInit {

  @Input('appColorHighlight') highlightValue;

  // @HostBinding('class')
  elementClass;

  constructor(private renderer: Renderer2, private el: ElementRef) {
  }

  ngOnInit() {
    switch (true) {
      case (this.highlightValue >= 5.0):
        this.renderer.addClass(this.el.nativeElement, 'v-low-color');
        break;
      case (this.highlightValue >= 1.5):
        this.renderer.addClass(this.el.nativeElement, 'low-color');
        break;
      case (this.highlightValue < 1.5 && this.highlightValue > -1.5):
        console.log(this.highlightValue);
        this.renderer.addClass(this.el.nativeElement, 'neutral-color');
        break;
      case (this.highlightValue <= -1.5):
        this.renderer.addClass(this.el.nativeElement, 'high-color');
        break;
      case (this.highlightValue <= -5.0):
        this.renderer.addClass(this.el.nativeElement, 'v-high-color');
        break;
    }
  }
}
